export { NavBarContainer as NavBar } from './NavBar.container';
